module.exports = __webpack_public_path__ + "static/img/img2-1.73fbbd8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/202403/img2-1.jpg
// module id = tsF7
// module chunks = 0